<template>
    <div class="main">
        <div class="body-content">
            <h1>Generate ODeX Report</h1>
            <div class="form-group">
                <div class="form-item">
                    <label for="partyname">Party *</label>
                    <v-select :clearable="false" tabindex="0" placeholder="Select Party Name" id="partyname"
                        v-model="newContainer.partyName" :options="party" label="short_name"
                        :reduce="party => party.autoid" selectOnTab="True" />
                </div>
                <div class="form-item">
                    <label for="fromdate">From Date </label>
                    <input type="text" id="fromdate" v-model="newContainer.fromdate" placeholder="dd/mm/yyyy"
                        v-on:blur="checkIsDate()" />
                </div>
                <div class="form-item">
                    <label for="todate">To Date </label>
                    <input type="text" id="todate" v-model="newContainer.todate" placeholder="dd/mm/yyyy"
                        v-on:blur="checkIsToDate()" />
                </div>
                <div class="form-item">
                    <label for="vesselName">Vessel *</label>
                    <v-select :clearable="false" id="vesselName" placeholder="Select Vessel"
                        v-model="newContainer.vesselID" ref="vesselName" :options="vessel" label="Name"
                        :reduce="vessel => vessel.Vesselid" selectOnTab="True" />
                </div>
                <div class="form-item">
                    <label for="voyageName">Voyage *</label>
                    <v-select :clearable="false" id="voyageName" v-model="newContainer.VoyId" :options="voyage"
                        label="Name" :reduce="voyage => voyage.Voyageid" selectOnTab="True" />
                </div>
                <div class="form-item">
                    <label for="location">Location:</label>
                    <v-select :clearable="false" id="location" v-model="newContainer.locID" :options="location"
                        label="Name" :reduce="location => location.locationid" selectOnTab="True" />
                </div>
                <div class="form-item">
                    <label for="location">Report Type:</label>
                    <select id="reportType" v-model="newContainer.reportType">
                        <option value="1" selected>PKGs</option>
                        <option value="2">Weight</option>
                        <option value="3">Missing SB</option>
                        <option value="4">Mismatch SB Pdf with ODeX</option>
                        <option value="5">ODeX Vessel Voyage Mismatched With Actual</option>
                        <option value="6">Vessel Report</option>
                        <option value="7">SCMTR Report After Sailing</option>
                        <option value="8">SCMTR Json SDM</option>
                    </select>
                </div>
                <div class="form-item">
                    <button type="button" class="excel-button" @click="ova_report(1)" :disabled="isSubmitting">View List</button>
                    <button type="button" class="excel-button" @click="ova_report(0)" :disabled="isSubmitting">Generate Report</button>
                </div>
            </div>
            <div class="form-item">
                <div v-html="htmlContent"></div>
            </div>
            
            <!-- Data Table -->
            <div v-if="tableData.length > 0" class="table-container">
                <div class="counter-bar">
                    <span class="unique-counter">No of Containers: <strong>{{ uniqueContainerCount }}</strong></span>
                    <span class="missing-counter">Missing SB: <strong>{{ missingSbCount }}</strong></span>
                </div>

                <table class="data-table">
                    <thead>
                        <tr>
                            <th>Sl No</th>
                            <th>Vessel Name</th>
                            <th>Voyage Name</th>
                            <th>Location</th>
                            <th>Description</th>
                            <th>Container</th>
                            <th>Booking No</th>
                            <th>SB No</th>
                            <th>SB Date</th>
                            <th>CIN</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(row, index) in tableData" :key="index" :class="{ 'missing-sb': (!row.sbno || !row.cin), 'duplicate-cont': isDuplicate(index) }">
                            <td>{{ index + 1 }}</td>
                            <td>{{ row.Vesselname }}</td>
                            <td>{{ row.voyagename }}</td>
                            <td>{{ row.LocationCode }}</td>
                            <td>{{ row.Description }}</td>
                            <td>{{ row.contnumber }}</td>
                            <td>{{ row.bookingno }}</td>
                            <td>{{ row.sbno || '-' }}</td>
                            <td>{{ row.sbdate || '-' }}</td>
                            <td>{{ row.cin || '-' }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
//import { part } from 'core-js/core/function';
import VSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import { useToast } from 'vue-toastification';
import * as cs from '../assets/js/commonscript.js'

export default {
    components: {
        VSelect,
    },
    data() {
        return {
            transactions: [],
            party: JSON.parse(localStorage.getItem('party')),
            accounts: JSON.parse(localStorage.getItem('accounts')) || [],
            applicants: JSON.parse(localStorage.getItem('applicants')) || [],
            vessel: JSON.parse(localStorage.getItem('vessel')) || [],
            voyage: JSON.parse(localStorage.getItem('voyage')) || [],
            ports: JSON.parse(localStorage.getItem('ports')) || [],
            location: JSON.parse(localStorage.getItem('Area')) || [],
            isSubmitting: false,
            newContainer: {
                partyName: 0,
                applicantID: 0,
                accountID: 0,
                vesselID: 0,
                VoyId: 0,
                locID: 0,
                fromdate: '',
                todate: '',
                reportType:'1'
            },
            htmlContent: null,
            tableData: [],
        }
    },
    computed: {
        missingSbCount() {
            if (!Array.isArray(this.tableData)) return 0;
            return this.tableData.filter(r => {
                // count as missing when `cin` is empty/undefined/null or only whitespace
                const cin = r && r.cin;
                return !cin || String(cin).trim() === '';
            }).length;
        }
        ,
        uniqueContainerCount() {
            if (!Array.isArray(this.tableData)) return 0;
            const set = new Set();
            this.tableData.forEach(r => {
                if (!r) return;
                const c = r.contnumber;
                if (c === undefined || c === null) return;
                const v = String(c).trim();
                if (v !== '') set.add(v);
            });
            return set.size;
        }
    },
    methods: {
        checkIsDate() {
            if (this.newContainer.fromdate != '') {
                if (cs.isvalidDate(this.newContainer.fromdate) == false) {
                    useToast().error('Invalid From Date');
                }
            }
        },
        checkIsToDate() {
            if (this.newContainer.todate != '') {
                if (cs.isvalidDate(this.newContainer.todate) == false) {
                    useToast().error('Invalid To Date');
                }
            }
        },
        updateApplicantAccountIds(value) {
            const AppAcc = cs.GetAppAccFromParty(value)
            this.newContainer.applicantID = AppAcc.applicantid
            this.newContainer.accountID = AppAcc.accountid
        },
        handleFileUpload(event) {
            this.newContainer.file = event.target.files[0];
        },
        async ova_report(gentype) {
            console.log(gentype)
            if (this.isSubmitting) return;            
            if (this.newContainer.partyName == 0) {
                useToast().error('Please select a party');
                return;
            }
            
            this.isSubmitting = true;
            
            try {
                this.updateApplicantAccountIds(this.newContainer.partyName)
                const token = localStorage.getItem('access_token');
                if (!token) {
                    useToast().error('Authentication token not found.');
                    return;
                }
                
                const config = {
                    headers: {
                        'accept': 'application/json',
                        'Authorization': `Bearer ${token}`,
                    },
                };
                var fromDt = ''
                var toDt = ''
                if (this.newContainer.fromdate != '') {
                    fromDt = cs.ConvertToISODate(this.newContainer.fromdate)
                }
                if (this.newContainer.todate != '') {
                    toDt = cs.ConvertToISODate(this.newContainer.todate)
                }
                const response = await axios.get('/generate_mismatch_pkg?applicant=' + this.newContainer.applicantID + '&account=' + this.newContainer.accountID + '&vessel=' + this.newContainer.vesselID + '&voyage=' + this.newContainer.VoyId + '&location=' + this.newContainer.locID + '&fromdate=' + fromDt + '&todate=' + toDt +'&rpttype='+this.newContainer.reportType +'&gentype='+gentype, config);
                console.log(response)
                if (response.data[0] === 0) {
                    useToast().error(response.data[1]);
                    this.tableData = [];
                } else {
                    if (gentype === 1) {
                        // View List mode - populate table
                        if (Array.isArray(response.data[2])) {
                            this.tableData = response.data[2];
                            useToast().success(`Loaded ${this.tableData.length} records`);
                        } else {
                            this.tableData = [];
                            useToast().warning('No data returned');
                        }
                    } else {
                        // Generate Report mode
                        this.tableData = [];
                        useToast().success(response.data[1]);
                    }
                }
            } catch (error) {
                console.error('Error generating report:', error);
                useToast().error(error.response?.data?.message || 'Error generating report.');
            } finally {
                this.isSubmitting = false;
            }
        }
        ,
        isDuplicate(index) {
            if (index === 0) return false;
            const current = this.tableData[index] && this.tableData[index].contnumber;
            const prev = this.tableData[index - 1] && this.tableData[index - 1].contnumber;
            if (!current || !prev) return false;
            return current === prev;
        }
    }
}
</script>

<style scoped>
/* Form group styling for form elements */
.form-group {
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
    margin-bottom: 5px;
}

.form-item {
    width: 30%;
}

select,
input[type="text"],
input[type="date"],
input[type="number"],
v-select {
    padding: 5px;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 14px;
    background-color: #FFF;
}

.excel-button {
    background-color: #17a2b8;
    color: white;
    border: none;
    padding: 10px 15px;
    border-radius: 5px;
    cursor: pointer;
    margin-right: 10px;
}

.excel-button:disabled {
    background-color: #6c757d;
    cursor: not-allowed;
    opacity: 0.6;
}

/* Data Table Styling */
.table-container {
    margin-top: 20px;
    overflow-x: auto;
    max-height: 600px;
    border: 1px solid #ddd;
    border-radius: 5px;
}

.data-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 14px;
    background-color: white;
}

.data-table thead {
    background-color: #17a2b8;
    color: white;
    position: sticky;
    top: 0;
    z-index: 10;
}

.data-table th,
.data-table td {
    padding: 8px 12px;
    text-align: left;
    border: 1px solid #ddd;
    white-space: nowrap;
}

.data-table tbody tr:hover {
    background-color: #f1f1f1;
}

.data-table tbody tr:nth-child(even) {
    background-color: #f9f9f9;
}

.data-table tbody tr.missing-sb {
    background-color: #ffcccc;
}

.data-table tbody tr.missing-sb:hover {
    background-color: #ffb3b3;
}

.data-table tbody tr.duplicate-cont {
    background-color: #fff8c6; /* light yellow */
}

.data-table tbody tr.duplicate-cont:hover {
    background-color: #fff1a8;
}

.counter-bar {
    padding: 8px 12px;
    background: #f7f7f7;
    border-bottom: 1px solid #e0e0e0;
}

.missing-counter {
    font-size: 14px;
    color: #333;
    margin-left: 18px;
}

.missing-counter strong {
    color: #c0392b;
}
.counter-bar .unique-counter {
    font-size: 14px;
    color: #333;
    margin-left: 18px;
}

.counter-bar .unique-counter strong {
    color: #2c3e50;
}
</style>